import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-create-video',
  templateUrl: './create-video.component.html',
  styleUrls: ['./create-video.component.css']
})
export class CreateVideoComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  errorMessage
  checkboxValue = false
  videoId
  buttonText
  videoType
  thumbnailUrl
  reg

  constructor(private formBuilder: FormBuilder, private authService: AuthservicesService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.videoType = environment.videoType
    this.errorMessage = environment.errorMessage
    this.route.params
      .subscribe(
        (params) => {
          this.videoId = params['id'];
        }
      );



    this.getVideo()
    this.form = this.formBuilder.group({
      videoUrl: ['', Validators.required],
      isShown: [''],
      title: [''],
      type: ['', Validators.required],
      thumbnailUrl: [''],
      channelThumbnailUrl: ['']
    })

  }



  get f() { return this.form.controls }


  setRegrex(event) {
    let type = event.target.value

    switch (type) {
      case 'Facebook':
        this.reg = /(?:(?:http|https):\/\/)?(?:www.)?facebook.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\-]*)?/
        break;
      case 'Vimeo':

        this.reg = /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/
        break;
      case 'Youtube':
        this.reg = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/
    }

    this.form.get('videoUrl').setValidators([Validators.required, Validators.pattern(this.reg)])
    this.form.get('videoUrl').updateValueAndValidity();

  }

  getValue(event) {
    this.checkboxValue = event.target.checked
  }
  getVideo() {
    this.authService.getVideo().subscribe((res: any) => {
      res.items.forEach(e => {
        this.thumbnailUrl = ''


        if (e._id == this.videoId) {
          if (e.videoType == 'Youtube') { this.thumbnailUrl = e.thumbnailUrl }
          else if (e.videoType != 'Youtube') { this.thumbnailUrl = e.channelThumbnailUrl }
          this.checkboxValue = e.isShown
          this.form.patchValue({
            videoUrl: e.videoUrl,
            isShown: e.isShown,
            title: e.videoTitle,
            type: e.videoType,
            thumbnailUrl: e.thumbnailUrl,
            channelThumbnailUrl: e.channelThumbnailUrl
          })
          return
        }
      });

    },
      error => {
        console.log(error)
      })
  }

  formRequest() {
    if (this.videoId != undefined) {
      this.onUpdate()
    }
    else {
      this.onSubmit()

    }
  }



  onSubmit() {
    this.form.get('isShown').setValue(this.checkboxValue)
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    let videoCheck = this.form.get('type').value
    if (videoCheck == 'Youtube') {
      this.form.get('thumbnailUrl').setValue(this.thumbnailUrl)
    }
    else if (videoCheck != 'Youtube') {
      this.form.get('channelThumbnailUrl').setValue(this.thumbnailUrl)
    }

    let formData = this.form.value;
    let formObj = {
      channelThumbnailUrl: formData.channelThumbnailUrl,
      isShown: formData.isShown,
      thumbnailUrl: formData.thumbnailUrl,
      title: "",
      type: formData.type,
      videoUrl: formData.videoUrl
    }

    this.authService.addVideo(formObj).subscribe((res: any) => {
      this.authService.successMessage(res.message, 'success').then((res) => {
        if (res.value) this.router.navigate(['/video-manager'])
      })
    },

      error => {
        this.authService.successMessage(error.error.message, 'error')
      })
  }



  uploadBanner(event) {
    if (event.target.files.length == 0) {
      return
    }
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('image', file, file.name);
      formData.append('imageType', 'coverImage');
      this.authService
        .upload(formData)
        .subscribe(
          data => {
            this.thumbnailUrl = environment.basePath + data['data'].url;
          },
          error => {
            this.authService.successMessage(error.error.message, 'error')

          }
        );
    } else {
      this.authService.successMessage('Error', 'error')

    }
  }





  renderImage(data) {
    let imgUrl
    let res = data.includes('https://')
    if (res) {
      imgUrl = data
    }
    else {
      imgUrl = this.authService.spilturl(data)
    }
    return imgUrl
  }





  onUpdate() {
    this.form.get('isShown').setValue(this.checkboxValue)
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }

    let videoCheck = this.form.get('type').value
    if (videoCheck == 'Youtube') {
      this.form.get('thumbnailUrl').setValue(this.thumbnailUrl)
    }
    else if (videoCheck != 'Youtube') {
      this.form.get('channelThumbnailUrl').setValue(this.thumbnailUrl)
    }


    let formObj = this.form.value
    formObj['videoId'] = this.videoId
    this.authService.editvideo(formObj).subscribe((res: any) => {
      this.authService.successMessage(res.message, 'success').then((res) => {
        if (res.value) this.router.navigate(['/video-manager'])
      })
    },

      error => {
        this.authService.successMessage(error.error.message, 'error')
      })
  }


}
